import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./hooks/auth/useAuth";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Dashboard from "./pages/Dashboard";
import VideosPage from "./pages/VideosPage";
import RoutesPage from "./pages/RoutesPage";
import ReportsPage from "./pages/ReportsPage";
import UsersListPage from "./pages/UsersListPage";
//import HeatmapPage from "./pages/Heatmap";
import RoutesMapPage from "./pages/RoutesMapPage";
import Sidebar from "./components/ui/Sidebar";

function PrivateLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-camber-gray-600">Loading...</p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen bg-camber-gray-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area - with fixed left padding for narrow sidebar (66px) */}
      <main className="flex-1 overflow-auto pl-[66px]">
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />

          <Route element={<PrivateLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/users" element={<UsersListPage />} />
            <Route path="/users/new" element={<Navigate to="/users" replace />} />
            <Route path="/routes" element={<Outlet />}>
              <Route index element={<RoutesPage />} />
              {/* <Route path="heatmap" element={<HeatmapPage />} /> */}
              <Route path="map" element={<RoutesMapPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
